/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Floating label for the 48px / 40px outlined controls.
 *
 * The rest position is the vertical centre of the control; the floated label
 * renders at 12px (16px scaled by MUI's 0.75). The notch legend is pinned to
 * the same 12px instead of an em fraction so it stays the right width now that
 * medium and small controls use different font sizes.
 */

import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import pxToRem from "assets/theme/functions/pxToRem";

const { brand, text, error } = colors;
const { fontFamily } = typography;

const inputLabel = {
  styleOverrides: {
    root: {
      fontFamily,
      fontSize: pxToRem(14),
      lineHeight: 1.4,
      color: text.focus,
      "&.Mui-focused": {
        color: brand.primary,
      },
      "&.Mui-error": {
        color: error.main,
      },
    },

    outlined: {
      "&:not(.MuiInputLabel-shrink)": {
        transform: `translate(${pxToRem(14)}, ${pxToRem(14)}) scale(1)`,
      },
      "&.MuiInputLabel-shrink": {
        fontSize: pxToRem(16),
        lineHeight: 1.5,
        fontWeight: 500,
        transform: `translate(${pxToRem(14)}, ${pxToRem(-9)}) scale(0.75)`,
        "~ .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend": {
          fontSize: pxToRem(12),
          fontWeight: 500,
        },
      },
    },

    sizeSmall: {
      fontSize: pxToRem(13),
      "&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
        transform: `translate(${pxToRem(12)}, ${pxToRem(11)}) scale(1)`,
      },
      "&.MuiInputLabel-shrink": {
        fontSize: pxToRem(16),
        lineHeight: 1.5,
        transform: `translate(${pxToRem(12)}, ${pxToRem(-9)}) scale(0.75)`,
      },
    },
  },
};

export default inputLabel;
